// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Document_wrapper__3XboC","title":"Document_title__3o7MH","name":"Document_name__jE0vK"};